(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"));
	else if(typeof define === 'function' && define.amd)
		define("@wix/wix-form-builder", ["_"], factory);
	else if(typeof exports === 'object')
		exports["@wix/wix-form-builder"] = factory(require("_"));
	else
		root["@wix/wix-form-builder"] = factory(root["_"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__39479__) => {
return 